import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import HowItWorksFaq from "./HowItWorksFaq";

export default function HowItWorksSection() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const isHowItWorksRoute = pathname === "/how-it-works";

  const steps = [
    {
      number: "1",
      title: "Choose Your Days",
          text: "Head to the Passes page. Select the number of days you want (Grommet, Little Bum, and Baby Bum passes are for kids!) and purhcase instantly.",
    },
    {
      number: "2",
      title: "Map Out the Fun",
      text: "Use our Discover Page to see all your included adventures, from Dolphin Cruises to Crab Island excursions. Your digital pass is delivered straight to your phone!",
    },
    {
      number: "3",
      title: "Scan & Go",
      text: "Arrive at your adventure, open the Beach Bum Pass app, and present your QR Code. Your admission is 100% included - just scan your pass and enjoy!",
    },
  ];

  const faqs = [
    {
      q: "When does my pass activate?",
      a: "Your pass DOES NOT activate at checkout. Your pass activates on your first valid scan at a participating Beach Bum Pass attraction.",
      },
      {
          q: "How do I redeem my pass at an attraction?",
          a: "Simply open your Beach Bum Pass app and present your QR Code. If you have Child Passes attached, navigate to the Child Passes section and assign your Little Beach Bum passes!",
      },
      {
          q: "How many times can I redeem my pass at each activity?",
          a: "Each activity may only be redeemed once per pass.",
      },
    {
      q: "Can I buy a pass for someone else?",
      a: "Yes. Purchase a pass and input their email address. Our system will send them an invite to download the app and claim their pass!",
    },
    {
      q: "Where can I view my child passes after purchase?",
      a: "After purchasing child passes, your Little Beach Bums can download the Beach Bum Pass app. Send an invite code to your little bums and they can claim their passes.",
    },
  ];

  const section = (
    <section className={`how-it-works${isHowItWorksRoute ? " visible" : ""}`}>
      <h2>How It Works</h2>
      <p className="howitworks-subtitle">
        Buy the pass that works for your trip, activate on the first scan!
      </p>

      <div className="how-steps">
        {steps.map((step) => (
          <div key={step.number} className="step visible">
            <span className="step-number">{step.number}</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </div>
        ))}
      </div>

      {isHowItWorksRoute ? <HowItWorksFaq items={faqs} /> : null}

      <button
        className="get-started-btn"
        onClick={() => nav(isHowItWorksRoute ? "/passes" : "/how-it-works")}
      >
        {isHowItWorksRoute ? "View Passes" : "Learn More"}
      </button>
    </section>
  );

  if (!isHowItWorksRoute) return section;

  return (
    <div className="page how-it-works-page">
      <div className="how-it-works-page__inner">
        <div className="how-it-works-page__topbar">
          <button className="how-it-works-page__back" onClick={() => nav(-1)}>
            ← Back
          </button>
          <h1 className="how-it-works-page__title">How it works</h1>
        </div>

        <div className="how-it-works-page__card">{section}</div>
      </div>
    </div>
  );
}
